:host {
  /**
   * @prop --color: Color of the note
   */
  color: var(--color);
  font-family: var(--ion-font-family, inherit);
  box-sizing: border-box;
}

:host(.ion-color) {
  color: var(--ion-color-base);
}

:host {
  --color: var(--ion-color-step-350, #a6a6a6);
}